import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import { classExists } from "../helper/class-exists";

const cardRating = () => {
  const elems = document.querySelectorAll(".js-card-rated");
  classExists(elems);

  elems.forEach(function (swiperClass) {
    const next = swiperClass.parentNode.querySelector(".swiper-button-next");
    const prev = swiperClass.parentNode.querySelector(".swiper-button-prev");
    let clickSlide = true;

    if(swiperClass.classList.contains('is-mobile')) {
      clickSlide = false;
    }
    
    const options = {
      modules: [Navigation],
      slidesPerView: "auto",
      slideToClickedSlide: clickSlide,
      observer: true,
      observeParents: true,
      spaceBetween: 16,
      breakpoints: {
        768: {
          spaceBetween: 24,
        },
      },
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
    };

    const swiper = new Swiper(swiperClass, options);
  });
};

const cardSwiperButtons = () => {
  const elems = document.querySelectorAll(".js-card-rated");
  classExists(elems);

  elems.forEach(function (swiperClass) {

    if(!swiperClass.parentNode.querySelector(".swiper-buttons")) {
      return;
    }

    const next = swiperClass.parentNode.querySelector(".swiper-button-next");
    const prev = swiperClass.parentNode.querySelector(".swiper-button-prev");
    const buttonElem = swiperClass.parentNode.querySelector('.swiper-buttons');

    if(next.classList.contains('swiper-button-lock') || prev.classList.contains('swiper-button-lock')) {
      buttonElem.classList.add('is-hidden');
      swiperClass.parentNode.parentNode.classList.remove('has-swiper-buttons');
    }
    else {
      buttonElem.classList.remove('is-hidden');
      swiperClass.parentNode.parentNode.classList.add('has-swiper-buttons');
    }
  })
}

const cardFlags = () => { 
  const buttons = document.querySelectorAll('.js-flag-toprated');

  buttons.forEach((button) => {
    button.querySelector(".more").addEventListener('click', (event) => {
      event.stopPropagation();
      button.querySelector(".more").parentElement.classList.toggle('is-open');
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  cardRating();
  cardSwiperButtons();
  cardFlags();
});

window.addEventListener(
  "resize",
  function (event) {
    cardSwiperButtons();
  },
  true
);
